// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { CollateralAgreementChangeRequest } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Model/Collateral';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

const useCollateralAgreementChangeRequests: () => UseQueryResult<
  TemplateContract<CollateralAgreementChangeRequest>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  return useQueryWithOptions({
    queryKey: ['queryCollateralAgreementChangeRequests'],
    queryFn: async (_, options) => {
      return ledgerApi.query(options, CollateralAgreementChangeRequest);
    },
  });
};

export default useCollateralAgreementChangeRequests;
